import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { colors, fonts } from "../theme";
import { View, Text, Card, Button, Press, ScreenHeader } from "../ui";
import { Icon } from "../Icon";
import { useI18n } from "../i18n";
import { useAppState } from "../state";
import { MATCH_ITEMS, shuffle, t } from "../content";

export default function Match() {
  const navigate = useNavigate();
  const { tr, lang } = useI18n();
  const { markDone } = useAppState();
  const item = MATCH_ITEMS[0];
  const rights = useMemo(() => shuffle(item.pairs.map((p, i) => ({ ...p.right, idx: i }))), []); // eslint-disable-line
  const [selLeft, setSelLeft] = useState(null);
  const [matched, setMatched] = useState({}); // leftIdx -> true
  const [wrong, setWrong] = useState(null);
  const done = Object.keys(matched).length === item.pairs.length;

  const pickRight = (rIdx) => {
    if (selLeft === null) return;
    if (rIdx === selLeft) {
      const nm = { ...matched, [selLeft]: true };
      setMatched(nm);
      setSelLeft(null);
      if (Object.keys(nm).length === item.pairs.length) markDone("matches", item.id);
    } else {
      setWrong(rIdx);
      setTimeout(() => setWrong(null), 500);
    }
  };

  return (
    <View style={{ flex: 1, minHeight: "100vh", backgroundColor: colors.surfaceSecondary }}>
      <ScreenHeader title={tr("matchIt")} onBack={() => navigate(-1)} />
      <View style={{ padding: 20 }}>
        <Text style={{ fontWeight: fonts.regular, fontSize: 14, color: colors.muted, marginBottom: 16 }}>{tr("matchPrompt")}</Text>
        <Text style={{ fontWeight: fonts.semibold, fontSize: 15, color: colors.onSurface, marginBottom: 16 }}>{t(item.prompt, lang)}</Text>
        <View row style={{ gap: 12, alignItems: "flex-start" }}>
          <View style={{ flex: 1, gap: 10 }}>
            {item.pairs.map((p, i) => {
              const isMatched = matched[i];
              const isSel = selLeft === i;
              return (
                <Press key={i} testID={`match-left-${i}`} onClick={() => !isMatched && setSelLeft(i)}>
                  <Card style={{ padding: 12, minHeight: 60, justifyContent: "center", backgroundColor: isMatched ? colors.successSurface : isSel ? colors.brandTertiary : colors.surface, border: `1.5px solid ${isMatched ? colors.success : isSel ? colors.brandPrimary : colors.border}` }}>
                    <Text style={{ fontWeight: fonts.semibold, fontSize: 13, color: colors.onSurface }}>{t(p.left, lang)}</Text>
                  </Card>
                </Press>
              );
            })}
          </View>
          <View style={{ flex: 1, gap: 10 }}>
            {rights.map((r) => {
              const isMatched = matched[r.idx];
              const isWrong = wrong === r.idx;
              return (
                <Press key={r.idx} testID={`match-right-${r.idx}`} onClick={() => !isMatched && pickRight(r.idx)}>
                  <Card style={{ padding: 12, minHeight: 60, justifyContent: "center", backgroundColor: isMatched ? colors.successSurface : isWrong ? colors.errorSurface : colors.surface, border: `1.5px solid ${isMatched ? colors.success : isWrong ? colors.error : colors.border}` }}>
                    <Text style={{ fontWeight: fonts.medium, fontSize: 13, color: colors.onSurface }}>{t(r, lang)}</Text>
                  </Card>
                </Press>
              );
            })}
          </View>
        </View>
        {done && (
          <View style={{ marginTop: 20, gap: 12 }}>
            <Card style={{ alignItems: "center", padding: 20 }}>
              <Icon name="confetti" size={40} color={colors.success} weight="fill" />
              <Text style={{ fontWeight: fonts.bold, fontSize: 18, color: colors.onSurface, marginTop: 8 }}>{tr("correct")}</Text>
            </Card>
            <Button title={tr("done")} iconRight="check" onPress={() => navigate(-1)} />
          </View>
        )}
      </View>
    </View>
  );
}
